















import VueOptions from '@utils/VueOptions'
import Calendar from './Calendar'
import SeasonRuleForm from './SeasonRuleForm'
import OnsiteInputFormModal from './OnsiteInputFormModal'
import CalendarService from '@services/CalendarService'

settings =
  name: 'OnsiteEventsCalendar'

  vue:
    props: ['calendar']

    components: {
      Calendar,
      SeasonRuleForm,
      OnsiteInputFormModal,
    }

    data: ->
      isSeasonal: @calendar.seasons.length > 0
      inputFormModal:
        show: false
        config:
          startDay: null
          endDay: null

    computed:
      events: ->
        eventsClone = JSON.parse(JSON.stringify(@calendar.events))
        eventsClone.map((event) ->
          event.rrule = CalendarService.rruleFromString(event.rrule) if event.repeats
          event
        )

      actionsForCalendar: ->
        select: @calendarSelectDates
        promptToEdit: @promptToEdit
        promptToRemove: @promptToRemove
        sync: @syncEvents

      actionsForInputForm: ->
        addCalendarEvent: @addCalendarEvent
        updateCalendarEvent: @updateCalendarEvent

    methods:
      hiSeasonalChanged: (checked) ->
        @calendar.seasons = [] unless checked

      calendarSelectDates: (startDay, endDay) ->
        @inputFormModal =
          show: true
          config: { startDay, endDay }
      
      promptToEdit: (calendarEvent) ->
        { id, title, start: startDay, end: endDay, repeats, rrule } = calendarEvent
        event = { id, title, startDay, endDay, repeats }
        event.rrule = rrule if repeats
        @inputFormModal =
          show: true
          config: event

      syncEvents: (events) ->
        @calendar.events = events

      promptToRemove: (calendarEvent) ->
        @removeCalendarEvent calendarEvent.id

      addCalendarEvent: (calendarEvent) ->
        { title, startDay: start, endDay: end, repeats, seasonal, rrule, exrule } = calendarEvent
        id = @events.length + 1
        event = { id, title, start, end, repeats }
        event.rrule = CalendarService.rruleToString(rrule) if repeats
        event.exrule = exrule if seasonal

        @calendar.events.push event

      updateCalendarEvent: (calendarEvent) ->
        newEvent = { ...calendarEvent }
        newEvent.start = calendarEvent.startDay
        newEvent.end = calendarEvent.endDay

        if calendarEvent.repeats
          newEvent.rrule = CalendarService.rruleToString(calendarEvent.rrule)
        else
          delete newEvent.rrule

        @calendar.events = @calendar.events.map((event) ->
          if event.id is newEvent.id
            return newEvent
          else
            return event
        )

      removeCalendarEvent: (id) ->
        @calendar.events = @events.filter((e) -> e.id isnt parseInt(id))

export default VueOptions.vue settings
